import styled from 'styled-components';

const OnlineOptionsStyled = styled.div``;

export { OnlineOptionsStyled };
